import messages from '../constants/logMessages.json';
import logging, { getMessage } from './logging';

export const jsonToString = (json: object) =>
  JSON.stringify(json, null, 2)
    .replace(/"(\w+)":/g, '$1:')
    .replace(/"/g, "'");

const { dataHeading, infoRegular } = messages;

const removeDataObject = (dataLayer: any) => {
  const { ...dataLayerSansData } = dataLayer;
  return dataLayerSansData;
};

export const setAnalytics = (
  data: { event?: string; [key: string]: any } = {}
): void => {
  const analyticsData = data || {};
  const { omitDataObject, omitEvents = [] } = logging.getLogOptions();
  const { event = '' } = analyticsData;
  const dataLayer = omitDataObject
    ? removeDataObject(analyticsData)
    : analyticsData;
  const jsonDataLayer = jsonToString(dataLayer);
  if (!omitEvents.includes(event)) {
    logging.info(
      getMessage('dataLayer', [event, jsonDataLayer]),
      dataHeading,
      infoRegular
    );
  }
};

export const dataPointsChecker = (
  contextData: object,
  dataLayerKey: Partial<{ [key: string]: string }> | undefined
): void => {
  if (!dataLayerKey || Object.keys(dataLayerKey).length < 1) return;

  Object.keys(contextData).forEach((dataValueKey) => {
    const exit = Object.values(dataLayerKey).includes(`data.${dataValueKey}`);
    const logColor = exit
      ? 'background: #7FFFDA; color: #484848'
      : 'background: #FF0000; color: #FFFFFF';
    logging.info(
      `%c QAL: ${exit ? 'Good Job !!' : 'Bad !!'} "${dataValueKey}" - ${
        exit ? 'Correct Datapoint' : 'Not Exist'
      }`,
      logColor
    );
  });
};
